import { getData, postData, putData, deleteData } from './ajax';
import { ADD_ARTIST, UPDATE_ARTIST, REMOVE_ARTIST, FETCH_ARTIST, FETCH_ARTISTS, ARTIST_ERROR } from './types';

// getData(action, errorType, isAuthReq, url, dispatch) {

export function fetchArtists() {
	const url = '/artists';
	return (dispatch) => getData(FETCH_ARTISTS, ARTIST_ERROR, true, url, dispatch);
}